(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initHeroMenu = (heroElement) => {
      if (!heroElement || heroElement.dataset.heroMenuBound === 'true') return;

      const menuToggle = heroElement.querySelector('[data-hero-menu-toggle]');
      const menuPanel = heroElement.querySelector('[data-hero-menu-panel]');
      if (!menuToggle || !menuPanel) return;

      // Teleport menu to body so mix-blend-mode: difference blends globally with all products, backgrounds, and footers
      if (menuToggle.parentElement !== document.body) {
        document.body.appendChild(menuToggle);
      }
      if (menuPanel.parentElement !== document.body) {
        document.body.appendChild(menuPanel);
      }

      const closeMenu = () => {
        heroElement.classList.remove('hero--menu-open');
        document.body.classList.remove('hero--menu-open');
        menuToggle.setAttribute('aria-expanded', 'false');
        menuPanel.setAttribute('aria-hidden', 'true');
      };

      const openMenu = () => {
        heroElement.classList.add('hero--menu-open');
        document.body.classList.add('hero--menu-open');
        menuToggle.setAttribute('aria-expanded', 'true');
        menuPanel.setAttribute('aria-hidden', 'false');
      };

      menuToggle.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (document.body.classList.contains('hero--menu-open') || heroElement.classList.contains('hero--menu-open')) {
          closeMenu();
        } else {
          openMenu();
        }
      });

      menuPanel.addEventListener('click', (event) => {
        if (event.target.closest('a')) {
          closeMenu();
          return;
        }

        event.stopPropagation();
      });

      document.addEventListener('click', (event) => {
        if (!document.body.classList.contains('hero--menu-open') && !heroElement.classList.contains('hero--menu-open')) return;
        if (event.target.closest('[data-hero-menu-panel], [data-hero-menu-toggle]')) return;
        closeMenu();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && (document.body.classList.contains('hero--menu-open') || heroElement.classList.contains('hero--menu-open'))) {
          closeMenu();
        }
      });
    };

    const init = () => {
      document.querySelectorAll('[data-hero-menu]').forEach(initHeroMenu);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Watermark dynamic parallax controller
    const initWatermarkParallax = () => {
      const watermarkItem = document.querySelector('[data-canalize-watermark]');
      const productSection = document.querySelector("[data-testid='product-list']");
      if (!watermarkItem || !productSection) return;

      let ticking = false;
      const updateWatermark = () => {
        const rect = productSection.getBoundingClientRect();
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;

        if (rect.bottom > 0 && rect.top < windowHeight) {
          const totalScrollable = rect.height - windowHeight;
          if (totalScrollable > 0) {
            const progress = Math.min(Math.max(-rect.top / totalScrollable, 0), 1);
            const translateY = (progress - 0.5) * 160;
            watermarkItem.style.transform = `translate3d(-1.5%, ${translateY.toFixed(2)}px, 0)`;
          }
        }
        ticking = false;
      };

      const onScroll = () => {
        if (!ticking) {
          window.requestAnimationFrame(updateWatermark);
          ticking = true;
        }
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      updateWatermark();
    };

    initWatermarkParallax();
    const mobileQuery = window.matchMedia('(max-width: 749px)');

    const setupSectionAutoplay = (section) => {
      if (section.dataset.mobileAutoplay !== 'true') return;
      if (section.dataset.mobileAutoplayBound === 'true') return;

      section.dataset.mobileAutoplayBound = 'true';
      const intervalSeconds = Math.max(2, Number(section.dataset.mobileAutoplayInterval || 4));
      let intervalId = null;

      const getSlideshow = () => section.querySelector('.resource-list__carousel slideshow-component');

      const clearAutoplay = () => {
        if (!intervalId) return;
        clearInterval(intervalId);
        intervalId = null;
      };

      const tick = () => {
        const slideshow = getSlideshow();
        if (!slideshow || slideshow.disabled || slideshow.hasAttribute('dragging') || document.hidden) return;

        if (slideshow.atEnd && typeof slideshow.select === 'function') {
          slideshow.select(0, undefined, { animate: true });
          return;
        }

        if (typeof slideshow.next === 'function') {
          slideshow.next(undefined, { animate: true });
        }
      };

      const syncAutoplay = () => {
        clearAutoplay();
        if (!mobileQuery.matches) return;
        intervalId = window.setInterval(tick, intervalSeconds * 1000);
      };

      syncAutoplay();
      mobileQuery.addEventListener('change', syncAutoplay);
    };

    const init = () => {
      document.querySelectorAll('[data-testid="product-list"]').forEach(setupSectionAutoplay);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__productRecoMobileAutoplayInit) return;
    window.__productRecoMobileAutoplayInit = true;

    const sectionSelector = '[data-testid="product-recommendations-section"]';
    const slideshowSelector = '.resource-list.hidden--desktop .resource-list__carousel slideshow-component';
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const autoplayInterval = 2000;

    const bindSection = (section) => {
      if (!section || section.dataset.mobileRecoAutoplayBound === 'true') return;
      section.dataset.mobileRecoAutoplayBound = 'true';

      let intervalId = null;

      const getSlideshow = () => section.querySelector(slideshowSelector);

      const stopAutoplay = () => {
        if (!intervalId) return;
        window.clearInterval(intervalId);
        intervalId = null;
      };

      const tick = () => {
        const slideshow = getSlideshow();
        if (!slideshow || slideshow.disabled || slideshow.hasAttribute('dragging') || document.hidden) return;

        if (slideshow.atEnd && typeof slideshow.select === 'function') {
          slideshow.select(0, undefined, { animate: true });
          return;
        }

        if (typeof slideshow.next === 'function') {
          slideshow.next(undefined, { animate: true });
        }
      };

      const syncAutoplay = () => {
        stopAutoplay();
        if (!mobileQuery.matches) return;
        if (!getSlideshow()) return;
        intervalId = window.setInterval(tick, autoplayInterval);
      };

      const observer = new MutationObserver(syncAutoplay);
      observer.observe(section, { childList: true, subtree: true });

      section.addEventListener('pointerenter', stopAutoplay);
      section.addEventListener('pointerleave', syncAutoplay);
      mobileQuery.addEventListener('change', syncAutoplay);
      document.addEventListener('visibilitychange', syncAutoplay);

      syncAutoplay();
    };

    const init = () => {
      document.querySelectorAll(sectionSelector).forEach(bindSection);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
